import './App.css';
import request_logs from './API/API_Requests';
import Row from './components/Rows/Row';
import Banner from './components/Banner/Banner';
import Nav from './components/NavBar/Nav';

function App() {
  return (
    <div className="App">
      {/* Navbar */}
      <Nav/>
      {/* Banner */}
      <Banner /> 
      {/* Movie Poster Rows */}
      <Row title="NETLIX ORIGNALS" fetch_Url={request_logs.requests.fetch_N_Orignals} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} isLargeRow/>
      <Row title="TOP TRENDING" fetch_Url={request_logs.requests.fetch_N_Trending} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />
      <Row title="TOP RATED" fetch_Url={request_logs.requests.fetch_N_TopRated} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />
      <Row title="ACTION MOVIES" fetch_Url={request_logs.requests.fetch_N_Action} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />
      <Row title="COMEDY MOVIES" fetch_Url={request_logs.requests.fetch_N_Comedy} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />
      <Row title="HORROR MOVIES" fetch_Url={request_logs.requests.fetch_N_Horror} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />
      <Row title="ROMANCE MOVIES" fetch_Url={request_logs.requests.fetch_N_Romance} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />
      <Row title="DOCUMENTARIES" fetch_Url={request_logs.requests.fetch_N_Documentaries} fetch_ImgUrl={request_logs.fetch_img_requests.baseURL} />

    </div>
  );
}

export default App;
